import { Colors } from "@stacc/flow-ui-components";
import styled from "styled-components";

// Sub-header separating applicant / co-applicant blocks within the section.
export const PcrApplicantHeader = styled.div`
  font-weight: 600;
  font-size: 15px;
  padding: 12px 0 4px;
`;

// Small label above each table (e.g. "Loans", "Income 2026").
export const PcrTableLabel = styled.div`
  font-weight: 600;
  font-size: 13px;
  padding: 12px 0 6px;
`;

// Horizontal scroll container so wide tables never break the page layout.
export const PcrTableWrapper = styled.div`
  overflow-x: auto;
  margin-bottom: 8px;
`;

export const PcrTable = styled.table`
  border-collapse: collapse;
  width: 100%;
  font-size: 13px;

  th,
  td {
    text-align: left;
    padding: 6px 12px;
    border: 1px solid ${Colors.Snow};
    white-space: nowrap;
  }

  thead th {
    background-color: ${Colors.Grey4};
    color: ${Colors.Coal};
    font-weight: 600;
  }

  /* Row-header cells (credit summary labels) read like normal body text. */
  tbody th[scope="row"] {
    font-weight: 400;
  }

  tbody tr:nth-of-type(even) {
    background-color: ${Colors.Grey4};
  }

  td.numeric,
  th.numeric {
    text-align: right;
  }
`;

export const PcrEmpty = styled.div`
  padding: 7px 0;
  color: ${Colors.Grey1};
`;
